export default __webpack_public_path__ + "static/media/Background_00123.93684238.png";